import { ReactNode, useEffect, useRef, useState } from 'react'

// Keep chart headers and scroll targets in the document, but defer expensive
// chart layout until it is near the viewport. Once mounted, preserve the chart
// (and its layout) when scrolling away or receiving new results.
export const LazyMount = ({ children }: { children: ReactNode }) => {
  const container = useRef<HTMLDivElement>(null)
  const [hasBeenVisible, setHasBeenVisible] = useState(
    () => typeof IntersectionObserver === 'undefined'
  )

  useEffect(() => {
    if (hasBeenVisible || !container.current) return

    const observer = new IntersectionObserver(
      (entries) => {
        if (entries.some((entry) => entry.isIntersecting)) {
          setHasBeenVisible(true)
          observer.disconnect()
        }
      },
      { rootMargin: '200px' }
    )
    observer.observe(container.current)
    return () => observer.disconnect()
  }, [hasBeenVisible])

  // react-wordcloud sizes itself from this element, and the parent card item is
  // a flex row: full width keeps the chart from collapsing to its 300px minimum.
  // The min height prevents offscreen cards collapsing and all intersecting at once.
  return (
    <div ref={container} style={{ width: '100%', minHeight: 300 }}>
      {hasBeenVisible ? children : null}
    </div>
  )
}
